import { Box, Button, Card, Loader, MarketingPageLayout, MarketingPageLayoutContent, Page, WixDesignSystemProvider, Image } from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import HeroImage from "./hero.png";
import React, { useEffect } from "react";
import { ReactTagManager } from "react-gtm-ts";
import { useTranslation } from "react-i18next";
import { initAnalytics, track } from "./analytics";
import * as Icons from "@wix/wix-ui-icons-common";

const tagManagerArgs = { code: "GTM-WZQPMC7" };
const BASE_URL = "https://wix.certifiedcode.io/forward/_functions";
const WIX_APP_ID = "c0d59f1e-839b-4807-91d6-840e400279bb";

function App() {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  const instance = new URLSearchParams(window.location.search).get("instance");
  const [isUpgraded, setIsUpgraded] = React.useState(false);

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
    initAnalytics();
    loadInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function loadInstance() {
    fetch(BASE_URL + "/@certifiedcode/base-backend/instance", {
      method: "GET",
      headers: { Authorization: instance || "" },
    })
      .then((response) => response.json())
      .then((data) => { setIsUpgraded(data?.instance?.isFree === false); })
      .catch(() => {});
  }

  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;

  if (token) {
    window.location.href = `https://www.wix.com/installer/install?token=${token}&appId=${WIX_APP_ID}&redirectUrl=https://wix.certifiedcode.io/forward/_functions/@certifiedcode/base-backend/auth`;
    return (
      <WixDesignSystemProvider features={{ newColorsBranding: true }}>
        <Page height="100vh"><Page.Content>
          <Box height={"90vh"} direction="vertical" verticalAlign="middle"><Loader text={t("loading")} /></Box>
        </Page.Content></Page>
      </WixDesignSystemProvider>
    );
  }

  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <Card>
        <MarketingPageLayout removeImageHorizontalPadding removeImageVerticalPadding
          content={
            <Box height="840px" verticalAlign="middle">
              <MarketingPageLayoutContent title={t("forward-title")} content={t("forward-content")}
                actions={
                  <Box direction="vertical" gap="SP2">
                    <Button prefixIcon={<Icons.PremiumFilled />} skin={isUpgraded ? "premium-light" : "premium"} as="a" href={upgradeUrl} target="_blank" onClick={() => track("upgrade_clicked")}>{isUpgraded ? t("manage-plan") : t("upgrade")}</Button>
                    <Button skin="inverted" prefixIcon={<Icons.Reviews />} as="a" href={`https://bridget.reviews.certifiedcode.us/${WIX_APP_ID}${window.location.search}`} target="_blank" onClick={() => track("write_review_clicked")}>{t("forward-rate-button")}</Button>
                  </Box>
                }
              />
            </Box>
          }
          image={<Image borderRadius={0} src={HeroImage} />}
        />
      </Card>
    </WixDesignSystemProvider>
  );
}

export default App;
